<template>
  <div
    :title="tooltip"
    class="indicator-container"
    :class="{'ml-1 my-1': useDefaultMargins}"
  >
    <v-icon class="msr--text">
      edit
    </v-icon>
  </div>
</template>

<script>
export default {
  props: {
    useDefaultMargins: {
      type: Boolean,
      default: true,
    },
    tooltip: {
      type: String,
      default: function () {
        return this.$t('contentHasOverlayOptions');
      },
    },
  },
};
</script>

<style scoped>
.indicator-container {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayOptionsIndicator.vue